var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProgressBar } from '../../progress-bar';
import { RoundIcon } from '../../round-icon/round-icon';
import Typography from '../../typography/typography';
import * as styles from './points-progress-card.styles';
export var PointsProgressCard = function (_a) {
    var currentPoints = _a.currentPoints, maxPoints = _a.maxPoints, description = _a.description, badgeImage = _a.badgeImage;
    var percentageScore = (currentPoints / maxPoints) * 100;
    return (_jsxs("div", __assign({ className: styles.wrapper }, { children: [_jsxs("div", __assign({ className: styles.content }, { children: [_jsx(RoundIcon, { hexBackgroundColor: "tertiary", iconColor: "white", backgroundColor: "tertiary", icon: "PencilIcon", size: { w: '16', h: '16' } }), _jsx(Typography, { type: "h2", text: description, className: "ml-5 pt-2" }), _jsxs("div", __assign({ className: "h-16 w-16 p-2", style: {
                            position: 'relative',
                            overflow: 'hidden',
                            marginLeft: 'auto',
                        } }, { children: [badgeImage, _jsx("h1", __assign({ className: "text-2x1 font-semibold text-white", style: {
                                    textAlign: 'center',
                                    position: 'absolute',
                                    top: 0,
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    height: 'fit-content',
                                    margin: 'auto',
                                } }, { children: maxPoints }))] }))] })), _jsx("div", __assign({ className: "h-4 w-full" }, { children: _jsx(ProgressBar, { className: "h-2", label: "", subLabel: "", value: percentageScore, primaryColour: 'primary', secondaryColour: 'uiLight' }) }))] })));
};
//# sourceMappingURL=points-progress-card.js.map